import { Team__Aliados } from "../teams/Aliados";
import { Team__Cerveceros_MAIN } from "../teams/Cerveceros_MAIN";
import { Team__Apaches } from "../teams/Apaches";
import { Team__MeanMachine } from "../teams/MeanMachine";
import { Team__Nogaleros } from "../teams/Nogaleros";
import { Team__BallBrothers } from "../teams/BallBrothers";
import { Team__UT } from "../teams/UT";
import { Team__XLobos } from "../teams/XLobos";

const Aliados = {
  team: Team__Aliados,
  playingPlayers: [],

  goals: 59,
  penaltyGoals: 0,
  isWinner: false,
};

const Apaches = {
  team: Team__Apaches,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Cerveceros = {
  team: Team__Cerveceros_MAIN,
  playingPlayers: [],

  goals: 52,
  penaltyGoals: 0,
  isWinner: false,
};

const MeanMachine = {
  team: Team__MeanMachine,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const Nogaleros = {
  team: Team__Nogaleros,
  playingPlayers: [],

  goals: 50,
  penaltyGoals: 0,
  isWinner: false,
};

const BallBrothers = {
  team: Team__BallBrothers,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const UTPaquime = {
  team: Team__UT,
  playingPlayers: [],

  goals: 63,
  penaltyGoals: 0,
  isWinner: false,
};

const XLobos = {
  team: Team__XLobos,
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

// ====================
// ====================
// ====================

const GroupA1 = {
  team: {
    name: "1st Group A",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const GroupA2 = {
  team: {
    name: "2nd Group A",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const GroupB1 = {
  team: {
    name: "1st Group B",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

const GroupB2 = {
  team: {
    name: "2nd Group B",
    logoImage: null,
    teamImage: null,
    teamLogoColor: null,
    teamJerseyColor: null,
  },
  playingPlayers: [],

  goals: 0,
  penaltyGoals: 0,
  isWinner: false,
};

export const Jornada5 = {
  jornadaPosition: 5,
  matches: [
    {
      team1: Nogaleros,
      team2: Cerveceros,

      isCompleted: true,
      isPlaying: false,
      day: "Viernes",
      date: "2025-08-01",
      time: "15:00:00",
      location: "Centro Recreativo Lebaron",
    },
    {
      team1: UTPaquime,
      team2: Aliados,

      isCompleted: true,
      isPlaying: true,
      day: "Viernes",
      date: "2025-08-01",
      time: "16:00:00",
      location: "Centro Recreativo Lebaron",
    },
  ],
};
